<template>
  <div id="app ">
    <Hero />
    <Services />
    <!-- <Process /> -->
    <OurWork />
    <Profile />
    <Testimonials />
  </div>
</template>

<script>
import Hero from './sections/Hero.vue';
import Services from './sections/Services.vue';
import OurWork from './sections/OurWork.vue';
// import Process from './sections/Process.vue';
import Profile from './sections/Profile.vue';
import Testimonials from './sections/Testimonials.vue';

export default {
  name: 'app',
  components: {
    Hero,
    OurWork,
    // Process,
    Profile,
    Services,
    Testimonials,
  },
  mounted () {
  }
}
</script>

<style lang="scss">
#app {

}
</style>
